// uploadImagem.js
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './config';
import {
  allowedImageExtensions,
  deleteImagesById,
  removeFromImageCache,
} from './storageService';
import { invalidatePatientImageCache } from '../utils/patientImageCache';

const MIME_TO_EXT = {
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'image/gif': 'gif',
};

const normalizeExtension = (ext) => (ext === 'jpeg' ? 'jpg' : ext);

const getFileExtension = (file) => {
  const nameExt = file.name?.split('.').pop()?.toLowerCase();
  if (nameExt && allowedImageExtensions.includes(nameExt)) {
    return normalizeExtension(nameExt);
  }
  if (file.type && MIME_TO_EXT[file.type]) {
    return MIME_TO_EXT[file.type];
  }
  return 'jpg';
};

/**
 * Faz o upload de uma imagem para uma pasta específica com nome baseado no ID.
 * Remove imagens anteriores do mesmo ID (png, jpg, jpeg, etc.) antes de salvar.
 * @param {File} file - Arquivo de imagem a ser enviado.
 * @param {string} folder - Nome da pasta no storage (ex: 'patient', 'therapist').
 * @param {string|number} id - ID para nomear o arquivo (ex: 137.png).
 * @returns {Promise<string>} - URL da imagem salva.
 */
export const uploadImagem = async (file, folder, id) => {
  if (!file) throw new Error('Nenhuma imagem selecionada');

  const idStr = String(id);
  const extension = getFileExtension(file);

  await deleteImagesById(folder, idStr);

  const storageRef = ref(storage, `${folder}/${idStr}.${extension}`);

  await uploadBytes(storageRef, file);

  const downloadURL = await getDownloadURL(storageRef);

  console.log(`Imagem salva em ${folder}/${idStr}.${extension} | URL: ${downloadURL}`);

  try {
    if (folder === 'patient') {
      invalidatePatientImageCache(idStr);
    } else {
      removeFromImageCache(folder, idStr);
    }
  } catch (error) {
    console.warn('Não foi possível limpar cache da imagem:', error);
  }

  return downloadURL;
};
